<input (change)="picked($event)" multiple type="file">
<pre>{{currentIndex$ | async | json}}</pre>

<cdk-virtual-scroll-viewport [itemSize]="size" [maxBufferPx]="size" [minBufferPx]="size" class="example-viewport">
  <div *cdkVirtualFor="let img of images$ | async" [ngStyle]="{'height.px':size}">
    <img (load)="loaded($event)" [src]="img | showPrintFromDisk" />
  </div>
</cdk-virtual-scroll-viewport>
